import { createAction, props } from '@ngrx/store';

import { FundChartSecurityOrSecurityGroup, FundChartYCChartOptions } from 'ChartApp/ts/interfaces/fund-chart.interface';

export const addFundChartSecurities = createAction(
    '[Fund Chart] Add Fund Chart Securities',
    props<{
        fundChartSecurities: FundChartSecurityOrSecurityGroup[];
        fundChartChartOptions: FundChartYCChartOptions;
    }>()
);

export const removeFundChartSecurity = createAction(
    '[Fund Chart] Remove Fund Chart Security',
    props<{ fundChartSecurity: FundChartSecurityOrSecurityGroup }>()
);

export const setFundChartSecurities = createAction(
    '[Fund Chart] Set Fund Chart Securities',
    props<{ fundChartSecurities: FundChartSecurityOrSecurityGroup[] }>()
);

export const toggleFundChartSecurity = createAction(
    '[Fund Chart] Toggle Fund Chart Security',
    props<{ fundChartSecurity: FundChartSecurityOrSecurityGroup }>()
);

export const updateFundChartSecurityOrdering = createAction(
    '[Fund Chart] Update Fund Chart Security Ordering',
    props<{ oldIndex: number; newIndex: number }>()
);
